import React, { useEffect, useMemo, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Modal, useMediaQuery } from "@material-ui/core";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import {
  Button,
  SIZE,
  VARIANT,
  COLOR,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { useConnectWallet, useUserSelect } from "features/home/redux/hooks";
import styles from "./styles";
import { SiweMessage } from "siwe";
import { apiUrl } from "features/configure";
import axios from "axios";
import { SignInProvider } from "@qubic-js/core";
import { useNavigate } from "react-router-dom";
import {
  useAccount,
  useConnect,
  useDisconnect,
  useSignMessage,
  useNetwork,
} from "wagmi";
import _, { set } from "lodash";
import { getShortAddress } from "features/helpers/utils";
import {
  MartianWalletName,
  AptosWalletName,
  BloctoWalletName,
  RiseWalletName,
  useWallet,
} from "@manahippo/aptos-wallet-adapter";
import CustomDropdown from "components/CustomDropdown/CustomDropdown";
import { StyledDataSourceDropDown } from "features/form/CreateForm.styles";
import { StyledBackButton } from "./ConnectWallet.styles";
import styled from "@emotion/styled/macro";
import Box from "@mui/material/Box";

axios.defaults.withCredentials = true;
const useStyles = makeStyles(styles);

const renderChain = (name, img) => {
  return (
    <span style={{ display: "flex", alignItems: "center", fontWeight: 400 }}>
      <img
        src={require("assets/img/" + img)}
        className="smIcon"
        style={{
          borderRadius: 7,
          width: 14,
          height: 14,
          marginRight: 8,
          marginLeft: 8,
        }}
      />
      <span>{name}</span>
    </span>
  );
};

const getKeyWithTrueValue = (obj) => {
  return Object.keys(obj).find((key) => obj[key] === true);
};

export const ConnectorButton = styled("div")(({ theme }) => {
  return {
    borderRadius: 5,
    padding: "15px 5px",
    margin: "0 auto",
    backgroundColor: "white",
    margin: 4,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "0px 3px 7px 0px rgba(0, 0, 0, 0.10)",
    "&:hover": {
      border: `1px solid ${theme.customColors.blue[500]}`,
    },
  };
});

const ConnectWallet = ({
  chooseUser,
  buttonImg,
  restriction,
  title,
  notPass,
  hidden = false,
  defaultOpen = false,
  callback,
  checked,
  startAction,
  formLogin = false,
  gaAction,
  isQubic = false,
  extraText,
  aptosOnly = false,
  everPayOnly = false,
  evmOnly = false,
  isJoyId = false,
}) => {
  // 是否是哪條特定的鏈才需要show的狀況
  const specificChainOnly = useMemo(
    () =>
      getKeyWithTrueValue({
        aptos: aptosOnly,
        everPay: everPayOnly,
        evm: evmOnly,
      }),
    [aptosOnly, everPayOnly, evmOnly]
  );
  const [shortAddress, setShortAddress] = useState("");
  const [showOtherWallet, setShowOtherWallet] = useState(false);
  const { user, userSelect } = useUserSelect();
  const { chain } = useNetwork();
  const { authCheck, auth, userData, authCheckPending, signout } =
    useConnectWallet();
  const { signMessageAsync } = useSignMessage();
  const theme = useTheme();
  const computer = useMediaQuery(theme.breakpoints.up("sm"));
  const classes = useStyles();
  const { disconnect } = useDisconnect();
  const otherWalletContent = ["JoyID", "Qubic Wallet"];

  const {
    connect: aptosConnect,
    disconnect: aptosDisconnect,
    connected: aptosConnected,
    account: aptosAddress,
    signMessage: aptosSignMessage,
  } = useWallet();

  const buttonText = {
    user: "Take a form",
    creator: "Create a form",
  };
  const {
    address,
    isConnected,
    isConnecting,
    connector: activeConnector,
  } = useAccount({
    onConnect() {
      if (!computer) setRequestAuth(false);
    },
    onDisconnect() {
      setRequestAuth(false);
      signout();
    },
  });

  const { connect, connectors, error, pendingConnector } = useConnect({
    onError(error) {
      // console.log("Error", error);
      setRequestAuth(false);
    },
  });
  const navigate = useNavigate();
  const [open, setOpen] = useState(defaultOpen);
  const [requestAuth, setRequestAuth] = useState(false);
  const [useJoyId, setUseJoyId] = useState(isJoyId);
  const domain = window.location.host;
  const origin = window.location.origin;
  const [currentConnectors, setCurrentConnectors] = useState([]);
  const [env, setEnv] = useState(specificChainOnly ? specificChainOnly : "evm");
  const [crossWalletConnected, setCrossWalletConnected] = useState(false);

  useEffect(() => {
    authCheck();
    const id = setInterval(() => {
      authCheck();
    }, 10000);
    return () => {
      clearInterval(id);
    };
  }, []);

  useEffect(async () => {
    if (userData) {
      const addrs = _.get(userData, "address", "");
      if (addrs.length < 11) {
        setShortAddress(addrs);
      } else {
        setShortAddress(getShortAddress(addrs));
      }
      if (open && auth && crossWalletConnected) {
        if (formLogin) {
          callback();
          setRequestAuth(false);
        } else {
          if (!hidden) setOpen(false);
          setRequestAuth(false);
          navigate("/creator");
        }
      }
    }
  }, [userData]);

  useEffect(() => {
    let filteredConnectors = connectors;

    if (computer) {
      filteredConnectors = _.filter(filteredConnectors, function (connector) {
        return connector.name !== "MetaMask_Injected";
      });
      //computer version (don't use injected metamask, because switch wallet only works for MetaMaskConnector)
    } else {
      filteredConnectors = _.filter(filteredConnectors, function (connector) {
        return connector.name !== "MetaMask";
      });
      //mobile version (only show injected metamask)
    }
    if (!window.ethereum) {
      filteredConnectors = _.filter(filteredConnectors, function (connector) {
        return (
          connector.name !== "MetaMask" &&
          connector.name !== "MetaMask_Injected"
        );
      });
    }
    if (!window.BinanceChain) {
      filteredConnectors = _.filter(filteredConnectors, function (connector) {
        return connector.name !== "BinanceWallet";
      });
    } else {
      if (!window.ethereum) {
        window.ethereum = window.BinanceChain;
      }
    }

    if (showOtherWallet) {
      filteredConnectors = otherWalletContent
        .map((name) =>
          filteredConnectors.find((connector) => connector.name === name)
        )
        .filter((connector) => connector !== undefined);
    } else {
      const notShowArray = ["JoyID", "EverPay Wallet"];

      if (isQubic) {
        filteredConnectors = _.filter(filteredConnectors, function (connector) {
          return connector.name === "Qubic Wallet";
        });
      }

      filteredConnectors = _.filter(filteredConnectors, function (connector) {
        return !notShowArray.includes(connector.name);
      });
    }

    if (!window.ethereum) {
      if (!isQubic) {
        filteredConnectors = _.filter(filteredConnectors, function (connector) {
          return (
            connector.name == "WalletConnect" ||
            otherWalletContent.includes(connector.name)
          );
        });
      }
    }

    setCurrentConnectors(filteredConnectors);
  }, [computer, connectors, showOtherWallet]);

  useEffect(() => {
    if (isConnected || aptosConnected) {
      setCrossWalletConnected(true);
    } else {
      setCrossWalletConnected(false);
    }
  }, [isConnected, aptosConnected]);

  const connectorsImg = {
    "Browser Wallet": require("assets/img/BrowserWallet.png"),
    MetaMask: require("assets/img/MetaMask.png"),
    MetaMask_Injected: require("assets/img/MetaMask.png"),
    BinanceWallet: require("assets/img/binanceWallet.png"),
    WalletConnect: require("assets/img/WalletConnect.svg").default,
    "Qubic Wallet": require("assets/img/qubicWallet.svg").default,
    JoyID: require("assets/img/joyId.png"),
  };

  const aptosWallets = [MartianWalletName, RiseWalletName, AptosWalletName];

  const aptosConnectorImg = {
    [MartianWalletName]:
      "data:image/png;base64,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",
    [RiseWalletName]:
      "data:image/png;base64,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",
    [AptosWalletName]:
      "data:image/png;base64,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",
    [BloctoWalletName]:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjkwMjggMTIuMzAyNEMyMi4zOTEyIDEyLjMwMjQgMTcuOTg3NCAxNC4wNDIgMTQuNjk1MiAxNy4xMjhDMTEuMDg0NCAyMC41MTM3IDguNzk5MiAyNS41MTM4IDcuNDg5MzIgMzAuMjE3M0M2LjYzMTQgMzMuMjk1MyA2LjIwMTY0IDM2LjQ4NzYgNi4yMDE2NCAzOS42ODE0QzYuMjAxNjQgNDAuNjQ3MiA2LjI0MTI5IDQxLjYwNSA2LjMxNzQxIDQyLjU1MTdDNi40MTA5NyA0My43MDMgNy41MzIxNCA0NC41MDA3IDguNjQ4NTUgNDQuMTk5NEM5LjYyMjI0IDQzLjkzNzcgMTAuNjQ2NyA0My43OTY2IDExLjcwMjggNDMuNzk2NkMxMy44NzIyIDQzLjc5NjYgMTUuOTA1MiA0NC4zODY1IDE3LjY0OCA0NS40MTczQzE3LjY5MDggNDUuNDQyNiAxNy43MzIxIDQ1LjQ2OCAxNy43NzQ5IDQ1LjQ5MThDMjAuNjA3MiA0Ny4xODA3IDIzLjk0ODUgNDguMTA4NCAyNy41MTE4IDQ3Ljk4OTVDMzYuODA2MiA0Ny42ODE4IDQ0LjM5OTEgNDAuMTE5MSA0NC43NDE2IDMwLjgyNjJDNDUuMTE1OSAyMC42NTk2IDM2Ljk4NyAxMi4zMDA4IDI2LjkwNDQgMTIuMzAwOEwyNi45MDI4IDEyLjMwMjRaTTI2LjkwMjggMzguMzA4MUMyMi4zOTc1IDM4LjMwODEgMTguNzQ1NCAzNC42NTYgMTguNzQ1NCAzMC4xNTIzQzE4Ljc0NTQgMjUuNjQ4NiAyMi4zOTc1IDIxLjk5NDggMjYuOTAyOCAyMS45OTQ4QzMxLjQwODEgMjEuOTk0OCAzNS4wNjAyIDI1LjY0NyAzNS4wNjAyIDMwLjE1MjNDMzUuMDYwMiAzNC42NTc1IDMxLjQwODEgMzguMzA4MSAyNi45MDI4IDM4LjMwODFaIiBmaWxsPSIjMTRBQUZGIi8+CjxwYXRoIGQ9Ik0xOS41NjM3IDYuNjgyNjFDMTkuNTYzNyA5LjAzNDM2IDE4LjMzMTUgMTEuMjE2NCAxNi4zMDggMTIuNDE1M0MxNS4wMzc4IDEzLjE2ODYgMTMuODQ2OCAxNC4wNTgyIDEyLjc2ODUgMTUuMDcxNUMxMC4zNzU1IDE3LjMxMzkgOC41ODk4NSAyMC4wNjUzIDcuMjY3MjggMjIuNzkyOUM3LjAwNzIxIDIzLjMzMDQgNi4yMDAwMyAyMy4xNDAyIDYuMjAwMDMgMjIuNTQyM1Y2LjY4MjYxQzYuMjAwMDMgMi45OTI0MiA5LjE5MjQ1IDAgMTIuODgyNiAwQzE2LjU3MjggMCAxOS41NjUyIDIuOTkyNDIgMTkuNTY1MiA2LjY4MjYxSDE5LjU2MzdaIiBmaWxsPSIjMDA3NUZGIi8+Cjwvc3ZnPgo=",
  };

  const urlSignout = async () => {
    try {
      navigate("/logout");
    } catch (err) {
      // console.log(err);
    }
  };

  const signInWithEthereum = async (role) => {
    try {
      setRequestAuth(true);
      if (activeConnector.name == "Qubic Wallet") {
        const res = await axios.post(
          `${apiUrl}api/session/sign-in/address`,
          { address },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else if (activeConnector.name == "EverPay Wallet") {
        const res = await axios.post(
          `${apiUrl}api/session/sign-in/address`,
          { address: address, blockchain: "everPay" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        const message = await createSiweMessage(
          address,
          "(IMPORTANT!!) This will NOT require gas fee"
        );

        const signature = await signMessageAsync({ message });
        const res = await axios.post(
          `${apiUrl}api/session/sign-in`,
          JSON.stringify({ message, signature, role }),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }
      // setPopout(true);

      await authCheck();
      setRequestAuth(false);
      // setPopout(false);
    } catch (err) {
      setRequestAuth(false);
    }

    // navigate("form/create/list");
  };

  const signInWithAptos = async (role) => {
    try {
      setRequestAuth(true);
      const message = await createAptosMessage(aptosAddress);

      const signature = await aptosSignMessage(message);

      try {
        const res = await axios.post(
          `${apiUrl}api/session/sign-in/address`,
          { address: aptosAddress.address, blockchain: "aptos" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {
        console.log("error", error);
      }

      // const res = await axios.post(
      //   `${apiUrl}api/session/sign-in`,
      //   JSON.stringify({ message, signature, role }),
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      // if (res.data && res.status == 200) {
      //   ReactGA.event({
      //     category: "Status",
      //     action: "Login Success",
      //     label: "",
      //   });
      // }
      // setPopout(true);

      await authCheck();
      setRequestAuth(false);
      // setPopout(false);
    } catch (err) {
      setRequestAuth(false);
    }

    // navigate("form/create/list");
  };

  const createAptosMessage = async (wallet) => {
    const res = await axios.get(`${apiUrl}api/session/nonce`);
    const payload = {
      message: `Metaform wants you to sign in with your Aptos account: ${wallet.address}`,
      address: wallet.address,
      publicKey: wallet.publicKey,

      nonce: res.data,
    };

    return payload;
  };

  const createSiweMessage = async (address, statement) => {
    const res = await axios.get(`${apiUrl}api/session/nonce`);

    const numOfHours = 168;
    var expirationTime = new Date();
    expirationTime.setTime(
      expirationTime.getTime() + numOfHours * 60 * 60 * 1000
    );

    const message = new SiweMessage({
      domain,
      address,
      statement,
      uri: origin,
      version: "1",
      chainId: chain.id,
      nonce: res.data,
      expirationTime: expirationTime.toISOString(),
    });
    return message.prepareMessage();
  };
  const renderConnecting = () => {
    return (
      <>
        <img
          src={
            connectorsImg[pendingConnector?.name] ||
            require("assets/img/MetaMask.png")
          }
          className="lgIcon"
        />

        <img
          src={require("assets/img/loading.gif")}
          className="lgIcon"
          style={{ marginTop: 30 }}
        />
        <div>{"Connecting…"}</div>
      </>
    );
  };
  const renderLoginButton = () => {
    return (
      <>
        {auth ? (
          ""
        ) : (
          <div
            style={{
              margin: "14px 0",
              fontWeight: 400,
              fontSize: 17,
              marginTop: 38,
            }}
          >
            Please sign in to continue
          </div>
        )}
        <Button
          color={COLOR.PRIMARY}
          size={SIZE.XL}
          fullWidth
          onClick={async () => {
            if (aptosConnected) {
              await signInWithAptos(user);
            } else {
              await signInWithEthereum(user);
            }
          }}
        >
          SIGN IN
          <img
            src={require("assets/img/loginW.svg").default}
            style={{ marginLeft: 10 }}
          />
        </Button>
        <Button
          variant={VARIANT.TEXT}
          color={COLOR.PRIMARY}
          onClick={() => {
            signout();
            disconnect();
            aptosDisconnect();
            // authCheck();
            setRequestAuth(false);
          }}
        >
          Try other wallet
        </Button>
      </>
    );
  };
  const renderLoginPage = () => {
    return (
      <div style={{ textAlign: "center", paddingTop: 30, paddingBottom: 20 }}>
        <div className="row">
          <div style={{ fontWeight: 600, fontSize: computer ? 20 : 16 }}>
            Welcome to{" "}
          </div>
          <img
            src={require("assets/img/title.svg").default}
            style={{ height: 24, marginLeft: 8 }}
          />
        </div>
        <div style={{ fontWeight: 400, fontSize: 14, margin: "25px 0" }}>
          Connected Address:{" "}
          <span style={{ fontSize: 23, fontWeight: 600 }}>
            {aptosConnected
              ? getShortAddress(aptosAddress.address)
              : getShortAddress(address)}
          </span>
        </div>
        {requestAuth ? (
          <div>
            <img
              style={{ marginTop: "25px" }}
              src={require("assets/img/loading.gif")}
              className="lgIcon"
            />
            <div style={{ fontWeight: 400 }}>Sign in...</div>
          </div>
        ) : (
          <div>{renderLoginButton()}</div>
        )}
      </div>
    );
  };

  const renderModalContent = () => {
    if (formLogin && auth && checked && !notPass) {
      return (
        <>
          {renderConnectedPage()}
          {restriction ? restriction : ""}
        </>
      );
    } else if (crossWalletConnected) {
      return (
        <>
          {renderLoginPage(true)}
          {restriction && restriction}
          {extraText && extraText}
        </>
      );
    } else if (isConnecting) {
      return renderConnecting();
    } else {
      return (
        <>
          {renderChooseWallet()}
          {restriction ? restriction : ""}
        </>
      );
    }
  };
  const renderJoyIdWallet = () => {
    const connector = _.find(connectors, { name: "JoyID" });
    if (!connector) return;
    return (
      <div style={{ width: "100%" }}>
        <div className={classes.title}>Choose your wallet</div>

        <Grid container style={{ margin: "20px 0" }} justifyContent="center">
          <Grid item xs={12}>
            <div className={classes.connectText}>Recommended Wallet</div>
          </Grid>
          {renderWalletButton(
            connector,
            "the best way to Web3 for everyone",
            7
          )}
        </Grid>
        <Button
          variant={VARIANT.TEXT}
          color={COLOR.PRIMARY}
          onClick={() => {
            setUseJoyId(false);
          }}
        >
          {"- Login with other wallet -"}
        </Button>
      </div>
    );
  };

  const renderWalletButton = (connector, desc, width = 6) => {
    return (
      <Grid item xs={width} key={connector.name}>
        <ConnectorButton
          disabled={!connector.ready}
          key={connector.name}
          onClick={async () => {
            if (connector.name == "Qubic Wallet") {
              const provider = await connector.getProvider();
              provider.removeSignInProvider();
            }
            connect({ connector });
          }}
        >
          <div style={{ margin: "0 auto" }}>
            <img
              alt=""
              src={connectorsImg[connector.name]}
              style={{
                width: 60,
                height: 60,
              }}
            />

            <div className={classes.subHeader}>
              {connector.name == "JoyID" ? "JoyID Passkey" : connector.name}
            </div>
            <div className={classes.desc}>{desc}</div>
          </div>
        </ConnectorButton>
      </Grid>
    );
  };

  const handleChooseOtherWallet = (booleanValue) => {
    setShowOtherWallet(booleanValue);
  };

  const handleEverpay = async () => {
    const everPayConnector = _.find(connectors, {
      name: "EverPay Wallet",
    });
    if (everPayConnector) {
      await everPayConnector.getProvider();
      connect({ connector: everPayConnector });
    }
  };

  const renderChooseWallet = () => {
    if (useJoyId) {
      return renderJoyIdWallet();
    }
    return (
      <div style={{ width: "100%" }}>
        <div className={classes.title}>Choose your wallet</div>

        {showOtherWallet ? (
          <>
            <Box textAlign={"left"}>
              <StyledBackButton
                onClick={() => handleChooseOtherWallet(false)}
                mt="18px"
                mb="63px"
              >
                <Box
                  component="i"
                  marginRight="3px"
                  className="meta-crm-icon-ic_redo font-size-16"
                />
                Back
              </StyledBackButton>
              <Grid container sx={{ minHeight: "250px" }}>
                {currentConnectors.map((connector, i) => {
                  return renderWalletButton(connector);
                })}
              </Grid>
            </Box>
          </>
        ) : (
          <>
            <div
              className={classes.subtitle}
              style={{ margin: "18px auto", maxWidth: 308 }}
            >
              Please log in with your wallet
            </div>
            {!specificChainOnly && (
              <div>
                <StyledDataSourceDropDown
                  white
                  style={{ width: 160 }}
                  value={env}
                  onSelect={(e) => {
                    setEnv(e.target.value);
                  }}
                  data={[
                    { label: renderChain("EVM", "eth.png"), value: "evm" },
                    {
                      label: renderChain("Aptos", "aptos.png"),
                      value: "aptos",
                    },
                    {
                      label: renderChain("EverPay", "everID.png"),
                      value: "everPay",
                    },
                  ]}
                />
              </div>
            )}
            <Grid container>
              {!aptosOnly && env == "evm" && (
                <>
                  {currentConnectors.map((connector, i) => {
                    return renderWalletButton(connector);
                  })}
                  {!isQubic && (
                    <Grid item xs={6}>
                      <ConnectorButton
                        onClick={() => {
                          handleChooseOtherWallet(true);
                        }}
                      >
                        <div style={{ margin: "0 auto" }}>
                          <img
                            alt=""
                            src={
                              require("assets/img/ic_otherWallet.svg").default
                            }
                            style={{
                              width: 60,
                              height: 60,
                            }}
                          />

                          <div className={classes.subHeader}>Other Wallets</div>
                        </div>
                      </ConnectorButton>
                    </Grid>
                  )}
                </>
              )}

              {isQubic && (
                <Grid item xs={12}>
                  <div
                    style={{
                      borderTop: "1.5px solid #D8D8D8",
                      width: "calc(100% + 60px)",
                      margin: "24px 0",
                      marginLeft: "-30px",
                      position: "relative",
                    }}
                  >
                    {" "}
                    <span
                      style={{
                        background: "white",
                        position: "absolute",
                        padding: "0 10px",
                        top: "0px",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      or
                    </span>
                  </div>
                  <Button
                    fullWidth
                    variant={VARIANT.TEXT}
                    color={COLOR.INFO}
                    style={{
                      margin: 0.5,
                      border: "0.5px solid #A5A5A5",
                      borderRadius: 5,
                      padding: 11,
                      height: 50,
                    }}
                    onClick={async () => {
                      const googleConnector = _.find(connectors, {
                        name: "Qubic Wallet",
                      });
                      if (googleConnector) {
                        const provider = await googleConnector.getProvider();
                        provider.setSignInProvider(SignInProvider.GOOGLE);
                        connect({ connector: googleConnector });
                      }
                    }}
                  >
                    <img
                      alt=""
                      style={{ width: "90%", height: 38 }}
                      src={require("assets/img/loginbygoogle.svg").default}
                    />
                  </Button>
                </Grid>
              )}
              {!evmOnly && env == "aptos" && (
                <Grid container spacing={1}>
                  {aptosConnected ? (
                    <Button
                      variant={VARIANT.TEXT}
                      color={COLOR.INFO}
                      onClick={() => {
                        aptosDisconnect();
                      }}
                    >
                      Disconnect
                    </Button>
                  ) : (
                    _.map(aptosWallets, (connector, i) => {
                      return (
                        <Grid
                          item
                          xs={6}
                          key={i}
                          style={{ textAlign: "center" }}
                        >
                          <ConnectorButton
                            style={{
                              height: 110,
                              display: "flex",
                              alignItems: "center",
                            }}
                            key={connector}
                            onClick={async () => {
                              aptosConnect(connector);
                            }}
                          >
                            <div style={{ margin: "0 auto" }}>
                              <img
                                alt=""
                                src={aptosConnectorImg[connector]}
                                style={{
                                  width: computer ? 60 : 40,
                                  height: computer ? 60 : 40,
                                }}
                              />

                              <div className={classes.subHeader}>
                                {computer && connector}
                              </div>
                            </div>
                          </ConnectorButton>
                        </Grid>
                      );
                    })
                  )}
                </Grid>
              )}
              {env == "everPay" && (
                <Grid item xs={6} sx={{ margin: "0 auto" }}>
                  {" "}
                  <ConnectorButton
                    onClick={() => {
                      handleEverpay();
                    }}
                  >
                    <div style={{ margin: "0 auto" }}>
                      <img
                        alt=""
                        src={require("assets/img/everID.png")}
                        style={{
                          width: 60,
                          height: 60,
                        }}
                      />

                      <div className={classes.subHeader}>EverPay</div>
                    </div>
                  </ConnectorButton>
                </Grid>
              )}

              <Grid item xs={12}>
                {error && (
                  <div style={{ textAlign: "center", color: "red" }}>
                    {error.message}
                  </div>
                )}
              </Grid>
            </Grid>
          </>
        )}

        {window.ethereum && (
          <div
            style={{
              textAlign: "center",
              fontWeight: 400,
              fontSize: 14,
              color: "#777",
              maxWidth: 380,
              margin: "0 auto",
              marginTop: 20,
            }}
          >
            This wallet login is only for managing & participating MetaForm
            surveys
          </div>
        )}
      </div>
    );
  };
  const renderConnectedPage = () => {
    return (
      <div>
        <div className="column" style={{ height: 200 }}>
          <img
            src={require("assets/img/check.svg").default}
            style={{ height: 60, width: 60 }}
          />
          <h2>Connected</h2>

          <Button
            color={COLOR.PRIMARY}
            onClick={() => {
              if (!notPass) {
                setOpen(false);
                startAction();
              }
            }}
          >
            Start
          </Button>
        </div>
        <div style={{ border: "1px solid #E6E6E6" }} />
      </div>
    );
  };
  const renderModal = (canClose = true) => {
    return (
      <Modal
        style={{ zIndex: 6000 }}
        open={open}
        onClose={() => {
          if (canClose) {
            setRequestAuth(false);
            setOpen(false);
          }
        }}
        className={classes.modal}
      >
        <div className={classes.modalPaper}>{renderModalContent()}</div>
      </Modal>
    );
  };
  const chooseUserLogin = async (u) => {
    if (auth && user == u) {
      if (useDisconnect == "user") {
        navigate("/user");
      } else {
        navigate("/creator");
      }
    } else {
      userSelect(u);
      if (u == "user") {
        disconnect();
      }
      setOpen(true);
    }
  };
  if (hidden) {
    return <>{renderModal(false)}</>;
  }
  if (chooseUser) {
    return (
      <>
        {buttonImg ? (
          <img
            src={buttonImg}
            onClick={() => chooseUserLogin(chooseUser)}
            style={{
              height: 50,
              cursor: "pointer",
            }}
          />
        ) : (
          <Button
            style={{
              backgroundColor: "white",
              margin: 20,
              border: "1px solid #E6E6E6",
              borderRadius: 40,
              color: "#383538",
              width: 220,
              height: 44,
            }}
            onClick={() => chooseUserLogin(chooseUser)}
          >
            {buttonText[chooseUser]}
          </Button>
        )}

        {renderModal()}
      </>
    );
  }
  return (
    <div
      style={{
        marginBottom: computer ? 0 : 20,
        display: buttonImg && gaAction ? "inline" : "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {auth && (
        <>
          <Button
            color={COLOR.INFO}
            variant={VARIANT.TEXT}
            style={{
              backgroundColor: "transparent",
              color: "#383538",
              fontWeight: 500,
              opacity: 0.4,
              border: 0,
              fontSize: 13,
              borderRadius: 0,
              minWidth: 80,
            }}
            onClick={() => urlSignout()}
          >
            {"Sign Out"}
          </Button>
          {!computer && <br />}
        </>
      )}
      {auth ? (
        <>
          <img
            src={require(aptosConnected ||
              _.get(userData, "blockchain", "") == "aptos"
              ? "assets/img/aptos.png"
              : _.get(userData, "blockchain", "") == "everPay"
              ? "assets/img/everID.png"
              : "assets/img/eth.png")}
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
            }}
          />
          <Button
            color={COLOR.PRIMARY}
            style={{ marginLeft: 15, fontWeight: 700 }}
          >
            {shortAddress}
          </Button>
        </>
      ) : buttonImg && gaAction ? (
        <div
          style={{
            padding: 0,
            marginBottom: 30,
            marginLeft: 0,
            marginTop: 20,
            cursor: "pointer",
            display: "inline",
          }}
          onClick={() => {
            gaAction();
            let currentLocation = window.location.pathname;
            if (currentLocation.indexOf("login") >= 0) {
              chooseUserLogin(currentLocation.split("/")[1]);
            } else {
              chooseUserLogin("creator");
              // navigate("/selectUser");
            }
          }}
        >
          <img
            src={buttonImg}
            style={{
              maxWidth: "60vw",
              borderRadius: 10,
            }}
          />
        </div>
      ) : (
        <Button
          color="primary"
          style={{ marginLeft: 15, fontWeight: 700 }}
          onClick={() => {
            let currentLocation = window.location.pathname;
            if (currentLocation.indexOf("login") >= 0) {
              chooseUserLogin(currentLocation.split("/")[1]);
            } else {
              chooseUserLogin("creator");
              // navigate("/selectUser");
            }
          }}
        >
          Login | Connect
        </Button>
      )}
      {renderModal()}
    </div>
  );
};

export default ConnectWallet;
